<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-select
        :disabled="!isedite"
        :style="inputStyle"
        v-model="val"
        filterable
        ref="component"
        @change="handleChange"
        @visible-change="beforeSelect"
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled"
        />
      </el-select>
    </el-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'jtGroupSelect',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    options: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    focus() {
      this.$refs.component.focus()
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    // handleVisibleChange(visible) {
    //   if (!visible) {
    //     this.$emit('enter')
    //     _.delay(() => this.$emit('datas', null, this.val), 300)
    //   }
    // },
    handleChange() {
      this.$emit('enter')
      _.delay(() => this.$emit('datas', null, this.val), 300)
    },
    beforeSelect(visible) {
      if (visible) {
        this.$emit('beforeSelect')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background-color: #8cc5ff;
}
</style>
